// Swiperのコア機能とAutoplayモジュールをインポート
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

const $ = window.jQuery

function hexToRgba(hex, alpha = 1) {
  hex = hex.replace(/^#/, '');
  // 3桁のhexを6桁に変換
  if (hex.length === 3) {
      hex = hex.split('').map(c => c + c).join('');
  }
  // 6桁のhexからRGBを取得
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

$(function() {
  // HEX値の--color-secondaryをrgbaに変換して半透明にした色を登録（反転するので、secondaryの方）
  const root = document.querySelector(":root");
  let primaryHex = getComputedStyle(root).getPropertyValue("--color-secondary").trim();
  let secondaryHex = getComputedStyle(root).getPropertyValue("--color-secondary").trim();
  // headにstyle要素を追加して、rootに登録
  const style = document.createElement('style');
  style.textContent = `
    :root {
      --color-primary-0_06: ${hexToRgba(primaryHex, 0.06)};
      --color-secondary-0_06: ${hexToRgba(secondaryHex, 0.06)};
    }
  `;
  document.body.appendChild(style);

  // メニューの開閉
  let swiper = null
  $('#navButton').on('click', () => {
    $('body').attr('data-menu-open', $('body').attr('data-menu-open') === 'true' ? 'false' : 'true')
    setAuthorsAnimation()
  })

  // 執筆者のアニメーション
  // メニューの開閉状態に応じてswiperを作成or破棄
  function setAuthorsAnimation() {
    if ($('body').attr('data-menu-open') === 'true') {
      const isSP = window.innerWidth <= 999
      const slideCount = document.querySelectorAll('.swiper .swiper-slide').length
      let spaceBetween = 180
      if (isSP) {
        if (5 <= slideCount) {
          spaceBetween = 40
        } else {
          spaceBetween = 140
        }
      } else {
        if (5 <= slideCount) {
          spaceBetween = 80
        }
      }
      // ランダムに並び替え
      $('.swiper-wrapper').html(
        $('.swiper-wrapper>.swiper-slide').sort(function (a, b) {
          return [1, -1][Math.floor(Math.random() * 2)];
        })
      );
      swiper = new Swiper('.swiper', {
        modules: [Autoplay],
        spaceBetween,
        allowTouchMove: false,
        loop: true,
        slidesPerView: 'auto',
        speed: 4000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false
        }
      })
    } else if (swiper) {
      swiper.destroy(true, true)
    }
  }
  setAuthorsAnimation()
  // サインカーブのアニメーション
  function updateSlidePositions() {
    const slides = document.querySelectorAll('.swiper-slide');
    const isSP = window.innerWidth <= 999
    slides.forEach(slide => {
      const rect = slide.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const amplitude = isSP ? 60 : 100; // 波の振幅
      const frequency = isSP ? 0.013 : 0.01; // 周波数
      const phase = isSP ? Math.PI : 0; // 位相（isSPの時だけπを加算して、ずらし余白を調整）
      const yOffset = Math.sin(x * frequency + phase) * amplitude;
      slide.style.transform = `translateY(${yOffset}px)`;
    });
    requestAnimationFrame(updateSlidePositions);
  }
  updateSlidePositions();
})
